import { OwlOptions } from 'ngx-owl-carousel-o';

export const CATEGORY_CAROUSEL_OPTIONS: OwlOptions = {
  autoWidth: true,
  loop: false,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  dots: false,
  navText: [
    '<img class="category-facet-carousel-btn-icon" src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-left-bluegrey.svg" />',
    '<img class="category-facet-carousel-btn-icon" src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-right-bluegrey.svg" />',
  ],
  navSpeed: 700,
  autoplay: false,
  nav: true,
  margin: 6,
  responsiveRefreshRate: 300,
};
